import { TypographyProps, Grid } from '@mui/material';
import BulletedText from './BulletedText';
import { Children } from 'react';
import { useTranslation } from 'react-i18next';

const BulletedList: React.FC<TypographyProps> = ({
  children,
  sx,
  color,
  style,
  variant,
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Grid component='ul'>
      {Children.map(children, (child, index) => (
        <BulletedText key={index} color={color} sx={sx} style={style} variant={variant} {...rest}>
          {typeof child === 'string' ? t(child) : child}
        </BulletedText>
      ))}
    </Grid>
  );
};

export default BulletedList;
